export default {
    functional: true,
    render: function (createElement, context) {
        var data = {
            props: {
                name: 'expand',
            },
            on: {
                afterEnter: function (element) {
                    element.style.height = 'auto';
                },
                enter: function (element) {
                    var width = getComputedStyle(element).width;
                    element.style.width = width;
                    element.style.position = 'absolute';
                    element.style.visibility = 'hidden';
                    element.style.height = 'auto';
                    var height = getComputedStyle(element).height;
                    // @ts-ignore
                    element.style.width = null;
                    // @ts-ignore
                    element.style.position = null;
                    // @ts-ignore
                    element.style.visibility = null;
                    element.style.height = '0';
                    // Force repaint to make sure the animation is triggered correctly.
                    // tslint:disable-next-line
                    getComputedStyle(element).height;
                    setTimeout(function () {
                        element.style.height = height;
                    });
                },
                leave: function (element) {
                    var height = getComputedStyle(element).height;
                    element.style.height = height;
                    // Force repaint to make sure the animation is triggered correctly.
                    // tslint:disable-next-line
                    getComputedStyle(element).height;
                    setTimeout(function () {
                        element.style.height = '0';
                    });
                },
            },
        };
        return createElement('transition', data, context.children);
    },
};
//# sourceMappingURL=TransitionExpand.js.map